import { Auth } from 'aws-amplify'
import { LambdaClient, InvokeCommand } from '@aws-sdk/client-lambda'
import { Buffer } from 'buffer';

export default async function invoke(url,payload = {}) {
  const credentials = await Auth.currentCredentials()
  if ( Object.keys(payload).length < 1 ) {
    const user = await Auth.currentSession()
    payload["groups"] = user.getIdToken()["payload"]["cognito:groups"]
  }
  const client = new LambdaClient({
    credentials: Auth.essentialCredentials(credentials),
    region: "ap-northeast-1"
  })
  const input = {
    FunctionName: url,
    Payload: JSON.stringify(payload)
  }
  const command = new InvokeCommand(input)
  const response = await client.send(command)
  const data = JSON.parse(Buffer.from(response.Payload).toString());
  let body = data.body
  if (typeof body === "string") {
    try {
      body = JSON.parse(body);
    } catch (_) {
      // JSONでない場合はそのまま使う
    }
  }
  // Presigned URLが含まれていた場合
  if (body?.url) {
    const res = await fetch(body.url);
    const contentType = res.headers.get("Content-Type");
    if (contentType && contentType.includes("application/json")) {
      body = await res.json(); // ← JSONとして返す
    } else {
      body = await res.blob(); // ← JSONでないものはblobで返す
    }
  }
  return body;
}